import { render, staticRenderFns } from "./labManager.vue?vue&type=template&id=ed5a83d4&scoped=true&"
import script from "./labManager.vue?vue&type=script&lang=js&"
export * from "./labManager.vue?vue&type=script&lang=js&"
import style0 from "./labManager.vue?vue&type=style&index=0&id=ed5a83d4&prod&lang=css&"
import style1 from "./labManager.vue?vue&type=style&index=1&id=ed5a83d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5a83d4",
  null
  
)

export default component.exports